export default class EpiPoint {
    constructor(date, value) {
        this.date = date;
        this.value = value;
    }
    getDate() {
        return this.date;
    }
    getValue() {
        return this.value;
    }
}
